export const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.1464 0.146447C10.3417 -0.0488155 10.6582 -0.0488155 10.8535 0.146447C11.0487 0.341709 11.0487 0.658216 10.8535 0.853478L6.20699 5.49996L10.8535 10.1464C11.0487 10.3417 11.0487 10.6582 10.8535 10.8535C10.6582 11.0487 10.3417 11.0487 10.1464 10.8535L5.49996 6.20699L0.853478 10.8535C0.658216 11.0487 0.341709 11.0487 0.146447 10.8535C-0.0488155 10.6582 -0.0488155 10.3417 0.146447 10.1464L4.79293 5.49996L0.146447 0.853478C-0.0487667 0.658213 -0.048798 0.341693 0.146447 0.146447C0.341696 -0.0487513 0.658228 -0.0487517 0.853478 0.146447L5.49996 4.79293L10.1464 0.146447Z"
            fill="white"
        />
    </svg>
)
